export default __webpack_public_path__ + "static/media/home_background.22002d5a.jpg";